// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__0J2pL","total":"AdvancePaymentDetails_total__+5yCH","edit":"AdvancePaymentDetails_edit__YdFp7"};